import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportingRoutingModule } from './reporting-routing.module';
import { SharedModule } from '../shared/shared.module';
import { AudienceComponent } from './audience/audience.component';
import { HistoriqueLogComponent } from './historique-log/historique-log.component';
import { ExtractionParProfilComponent } from './extraction-par-profil/extraction-par-profil.component';
import { ExtractionComponent } from './extraction/extraction.component';
import { ExtractionParticulierComponent } from './extraction-particulier/extraction-particulier.component';
import { ExtractionCorporateComponent } from './extraction-corporate/extraction-corporate.component';
import { ExtractionProfessionnelComponent } from './extraction-professionnel/extraction-professionnel.component';
import { ExtractionProductProgramComponent } from './extraction-product-program/extraction-product-program.component';
import { ExtractionDemnadeParProfilComponent } from './extraction-demnade-par-profil/extraction-demnade-par-profil.component';
import { ExtractionDirectionComponent } from './extraction-direction/extraction-direction.component';


@NgModule({
  imports: [
    CommonModule,
    ReportingRoutingModule,
    SharedModule,
  ],

  declarations: [
    AudienceComponent,
    HistoriqueLogComponent,
    ExtractionParProfilComponent,
    ExtractionComponent,
    ExtractionParticulierComponent,
    ExtractionCorporateComponent,
    ExtractionProfessionnelComponent,
    ExtractionProductProgramComponent,
    ExtractionDemnadeParProfilComponent,
    ExtractionDirectionComponent
  ],

  entryComponents: [
    
  ],

  providers: [
  ],

})
export class ReportingModule { }